import script from "./Tweet.vue?vue&type=script&setup=true&lang=js"
export * from "./Tweet.vue?vue&type=script&setup=true&lang=js"

import "./Tweet.vue?vue&type=style&index=0&id=7b09f083&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b09f083"]])

export default __exports__